import React from 'react';
import { Link } from 'react-router-dom';

import NewNavButtonGroup from './NewNavButtonGroup';
import Loading from '../shared/Loading';

const NewExam = ({ changePage, loading, passed, ...rest }) => (
  <div className="">
    <div className="new-exam__body__quizLanding">
      <div className="new-exam__body__avt--06">AVT: 06</div>
      <div className="new-exam__body__header new-exam__body__quizLanding--margin">
        Quiz
      </div>

      <p>
        Great, that completes the online training side of the Accessible
        Vehicle & Service Driver Program here at Autzu. You are now ready
        to complete the multiple choice quiz.
      </p>

      <ul className="new-course__body__content__olist--ulist">
        <li>
          There are 20 questions and you need to score 15 or above (75%) to
          pass.
        </li>
        <li>
          The test is timed from the moment you log in and you have 45
          minutes to complete it, although it usually takes 20-25 minutes.
        </li>
        <li>
          Each question has four options and you must only choose one.
        </li>
        <li>Questions and answers are randomized.</li>
        <li>
          You are allowed a maximum of three attempts, after this you will
          need to retake the online training.
        </li>
      </ul>
      <br />
      <br />

      {loading ? <Loading size="2x" /> : null}
    </div>

    <div className="new-course__body__footer--desktop">
      <NewNavButtonGroup
        disabled={!passed}
        passed={passed}
        changePage={changePage}
        {...rest}
      />
    </div>
  </div>
);

export default NewExam;



// WEBPACK FOOTER //
// ./src/components/NewCourse/NewExam.js